import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-tables',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-tables works!</p> `,
  styles: ``,
})
export class CpTablesComponent {}
